import React from "react";
import Navigation from "@/layout/navigation";

export default function PrivacyPolicy() {
  return (
    <>
      {/* Header avec navigation */}
      <header className="bg-gradient-to-b from-white from-20% to-blue-300 flex flex-col gap-16 items-center justify-between overflow-hidden px-8 xl:px-0 z-[51] relative pb-20">
        <Navigation noMenu />
        <div className="flex flex-col md:items-center md:justify-center gap-4 mt-6 md:mt-10 z-10 md:text-center">
          <h1 className="text-4xl md:text-5xl font-medium leading-tight">
            Politique de Confidentialité
          </h1>
          <p className="text-md max-w-2xl mx-auto text-slate-600">
            Votre confidentialité est importante pour nous. Cette politique explique comment nous collectons, utilisons et protégeons vos informations personnelles.
          </p>
        </div>
      </header>

      {/* Contenu principal - ultra simple */}
      <div className="bg-white py-20 px-8 xl:px-0">
        <div className="max-w-3xl mx-auto">
          <div className="space-y-12 text-lg leading-relaxed text-gray-800">
            <div className="text-sm text-blue-600 font-medium">
              Dernière mise à jour : 28 septembre 2025
            </div>

            <div className="space-y-8">
              <p>
                Featcal (&quot;nous,&quot; &quot;notre,&quot; &quot;nos&quot;) s&apos;engage à protéger votre vie privée et à assurer la conformité avec les lois applicables sur la confidentialité, y compris la Loi canadienne sur la protection des renseignements personnels et les documents électroniques (PIPEDA) et la Loi québécoise sur la protection des renseignements personnels dans le secteur privé (Loi 25), ainsi que d&apos;autres réglementations internationales le cas échéant (comme le RGPD).
              </p>

              <p>
                Cette Politique de Confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations lorsque vous utilisez notre plateforme, site web (featcal.com), applications mobiles et services connexes (collectivement, les &quot;Services&quot;).
              </p>

              <p className="font-semibold">
                En utilisant Featcal, vous consentez aux pratiques décrites dans cette Politique de Confidentialité.
              </p>
            </div>

            {/* Le reste du contenu peut être ajouté ici si nécessaire */}
          </div>
        </div>
      </div>
    </>
  );
}
